import React, { useEffect, useRef, useState } from 'react';
import DynamicForm from '../FormBuilder/DynamicForm';
import FormContainer from '../FormBuilder/FormContainer';
import CourseCompletionService from './CourseCompletionService';
import { CityState } from '../Common/CityState';
import useFormSubmitErroHandler from '../../hooks/useFormSubmitErroHandler';
import FormSubmitAlertMsg from '../FormBuilder/FormSubmitAlertMsg';

function CourseCompletionForm(props) {
  let { current: scope } = useRef({ formFn: {} });

  const [isFormRendered, setFormRendered] = useState(false);
  const [post, setPost] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const { errorMsg, onError } = useFormSubmitErroHandler(scope.formFn.setLoading);

  const formId = 1314;
  const params = props.match.params;

  useEffect(() => {
    scope.data = {};
    scope.item = {};
    scope.formFn = {
      form_type: 'course_completions',
      editPermission: true
    };

    if (params.id) {
      scope.formMode = 'edit-form-submissions';
      getById(params.id);
    } else {
      scope.formMode = 'create-form-submissions';
      setFormRendered(true);
    }
  }, [params.id]);

  const getById = async (id) => {
    if (props.editItem) {
      scope.item = props.editItem;
      scope.data = scope.item.data || {};
      setFormRendered(true);
    }
  };

  const create = async (item) => {
    item.organization_id = params.organization_id;
    const { status, data } = await CourseCompletionService.create(item);
    if (status === 201) {
      if (props.onSubmit) props.onSubmit();
      onSubmitPageRedirect();
    } else {
      onError(data);
    }
  };

  const update = async (item) => {
    const { status, data } = await CourseCompletionService.update(item);
    if (status === 204) {
      if (props.onSubmit) props.onSubmit();
      onSubmitPageRedirect();
    } else {
      onError(data);
    }
  };

  const onSubmitPageRedirect = () => {
    if (props.isPopupMode) {
      props.toggleModal();
    } else {
      props.history.goBack();
    }
    setIsSubmitted(true);
  };

  if (isFormRendered) {
    return (
      <div id="ct">
        <FormContainer post={post} isPopupMode={true}>
          <FormSubmitAlertMsg isSubmitted={isSubmitted} errorMsg={errorMsg} />
          {!isSubmitted &&
            <DynamicForm
              formMode={scope.formMode}
              formId={formId}
              form={scope.item}
              formFn={scope.formFn}
              onCreate={create}
              onUpdate={update}
              data={scope.data}
              post={post}
              onCancel={onSubmitPageRedirect}
              setPost={setPost}
              isPopupMode={true} />
          }
          <CityState formFn={scope.formFn} data={scope.data} />
        </FormContainer>
      </div>
    );
  }

  return null;
}

export default CourseCompletionForm;